import { render, staticRenderFns } from "./persistentvolume.vue?vue&type=template&id=ee9c0998&"
import script from "./persistentvolume.vue?vue&type=script&lang=js&"
export * from "./persistentvolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports